module.exports = __webpack_public_path__ + "f813b9f2ff413a7d72a94bfe7c25f83a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sct/Logo_SMART.svg
// module id = 31
// module chunks = 1